import useWorkflows from 'api/workflows/useWorkflows';
import { NodeFormProps } from 'api/workflows-steps/formSchema';
import SubworkflowCommonForm from './SubworkflowCommonForm';
import { LoopWorkflowConfiguration } from 'api/model';
import { JumpToWorkflow } from 'components/button/JumpToWorkflow';

type LoopWorkflowProps = NodeFormProps & {
  validate?: boolean;
};

const LoopWorkflow = (props: LoopWorkflowProps) => {
  const { workflows } = useWorkflows();
  const config: LoopWorkflowConfiguration | undefined = props.formContext?.formData?.configuration;
  const workflow = workflows?.find((w) => w.id === config?.workflow_id);

  return (
    <>
      <SubworkflowCommonForm {...props} />
      {config && workflow && (
        <div className="flex justify-between">
          <JumpToWorkflow projectId={workflow.project_id} workflowId={workflow.id} revision={config.revision} />
        </div>
      )}
    </>
  );
};

export default LoopWorkflow;
